export function sendPushNotification(message) {
    Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
         message!=='enable'&& new Notification(
            message,
            {
              icon:  process.env.PUBLIC_URL + "/assets/images/smallLogo.webp",
            }
          );
        } else if (permission === "denied") {
        }
      });
}